import { useEffect, useState } from "react";

import api from "../services/api";

export default function TarifsRegionsPage() {
  const [regions, setRegions] = useState([]);
  const [saving, setSaving] = useState(null);
  const [success, setSuccess] = useState(null);

  const [selectedRegion, setSelectedRegion] = useState(null);
  const [heuresPointe, setHeuresPointe] = useState([]);
  const [loadingHeures, setLoadingHeures] = useState(false);
  const [savingHeure, setSavingHeure] = useState(false);

  const [newHeure, setNewHeure] = useState({
    heure_debut: "07:00",
    heure_fin: "09:00",
    multiplicateur: 1.25,
    actif: true,
  });

  useEffect(() => {
    api.get("/admin/tarifs-regions").then(res => setRegions(res.data));
  }, []);

  const save = async (region) => {
    setSaving(region.id);

    try {
      await api.put(`/admin/tarifs-regions/${region.id}`, region);

      setSuccess(region.id);
      setTimeout(() => setSuccess(null), 2000);
    } catch (err) {
      console.error(err);
    }

    setSaving(null);
  };

  const update = (id, field, value) => {
    setRegions(prev =>
      prev.map(r =>
        r.id === id ? { ...r, [field]: value } : r
      )
    );
  };

  const loadHeuresPointe = async (region) => {
    setSelectedRegion(region);
    setLoadingHeures(true);

    try {
      const res = await api.get(
        `/admin/tarifs-regions/${region.id}/heures-pointe`
      );

      setHeuresPointe(res.data);
    } catch (err) {
      console.error("Erreur chargement heures de pointe:", err);
      setHeuresPointe([]);
    }

    setLoadingHeures(false);
  };

  const addHeurePointe = async () => {
    if (!selectedRegion) return;

    setSavingHeure(true);

    try {
      const res = await api.post(
        `/admin/tarifs-regions/${selectedRegion.id}/heures-pointe`,
        {
          heure_debut: newHeure.heure_debut,
          heure_fin: newHeure.heure_fin,
          multiplicateur: Number(newHeure.multiplicateur),
          actif: newHeure.actif,
        }
      );

      setHeuresPointe(prev =>
        [...prev, res.data].sort((a, b) =>
          a.heure_debut.localeCompare(b.heure_debut)
        )
      );

      setNewHeure({
        heure_debut: "07:00",
        heure_fin: "09:00",
        multiplicateur: 1.25,
        actif: true,
      });
    } catch (err) {
      console.error("Erreur ajout heure de pointe:", err);
      alert(
        err.response?.data?.error ||
        "Impossible d'ajouter cette heure de pointe."
      );
    }

    setSavingHeure(false);
  };

  const updateHeurePointe = async (heure) => {
    if (!selectedRegion) return;

    try {
      const res = await api.put(
        `/admin/tarifs-regions/${selectedRegion.id}/heures-pointe/${heure.id}`,
        {
          heure_debut: heure.heure_debut,
          heure_fin: heure.heure_fin,
          multiplicateur: Number(heure.multiplicateur),
          actif: heure.actif,
        }
      );

      setHeuresPointe(prev =>
        prev.map(h => h.id === heure.id ? res.data : h)
      );
    } catch (err) {
      console.error("Erreur modification heure de pointe:", err);

      alert(
        err.response?.data?.error ||
        "Impossible de modifier cette heure de pointe."
      );
    }
  };

  const deleteHeurePointe = async (heure) => {
    if (!selectedRegion) return;

    if (
      !window.confirm(
        `Supprimer la plage ${heure.heure_debut} → ${heure.heure_fin} ?`
      )
    ) {
      return;
    }

    try {
      await api.delete(
        `/admin/tarifs-regions/${selectedRegion.id}/heures-pointe/${heure.id}`
      );

      setHeuresPointe(prev =>
        prev.filter(h => h.id !== heure.id)
      );
    } catch (err) {
      console.error("Erreur suppression heure de pointe:", err);

      alert(
        err.response?.data?.error ||
        "Impossible de supprimer cette heure de pointe."
      );
    }
  };

  const updateHeureLocal = (id, field, value) => {
    setHeuresPointe(prev =>
      prev.map(h =>
        h.id === id ? { ...h, [field]: value } : h
      )
    );
  };

  const columns = [
    { field: "prix_base", label: "Base (CFA)", step: 50 },
    { field: "prix_par_km", label: "Par km (CFA)", step: 50 },
    { field: "prix_par_min", label: "Par min (CFA)", step: 5 },
    { field: "prix_minimum", label: "Min (CFA)", step: 50 },
    { field: "multiplicateur", label: "Multiplicateur", step: 0.1 },
    { field: "frais_approche_1km", label: "< 1km", step: 50 },
    { field: "frais_approche_2km", label: "1-2km", step: 50 },
    { field: "frais_approche_3km", label: "2-3km", step: 50 },
    { field: "frais_approche_4km", label: "3-4km", step: 50 },
    { field: "frais_approche_5km", label: "> 4km", step: 50 },
  ];

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "1.5rem",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: 22,
              fontWeight: 500,
              color: "#0B3C5D",
            }}
          >
            🗺️ Tarifs par région
          </h1>

          <p
            style={{
              fontSize: 14,
              color: "#888",
              marginTop: 4,
            }}
          >
            Prix dynamiques par région — base + km + min + approche × multiplicateur
          </p>
        </div>

        <div
          style={{
            fontSize: 12,
            padding: "4px 14px",
            borderRadius: 20,
            background: "#E6F1FB",
            color: "#185FA5",
            border: "0.5px solid #B5D4F4",
          }}
        >
          🗺️ {regions.length} régions
        </div>
      </div>

      {/* Formule */}
      <div
        style={{
          background: "#f7f7f7",
          borderRadius: 10,
          padding: 14,
          marginBottom: 16,
          fontSize: 13,
          color: "#0B3C5D",
        }}
      >
        💡 <strong>Formule :</strong>{" "}
        (Base + km × dist + min × durée + frais approche)
        × multiplicateur région × multiplicateur de la plage de pointe
      </div>

      {/* Table */}
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          border: "0.5px solid #e5e5e5",
          overflow: "auto",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: 1000,
          }}
        >
          <thead style={{ background: "#0B3C5D" }}>
            <tr>
              <th
                style={{
                  padding: "12px 14px",
                  textAlign: "left",
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#fff",
                  position: "sticky",
                  left: 0,
                  background: "#0B3C5D",
                }}
              >
                Région
              </th>

              {columns.map(c => (
                <th
                  key={c.field}
                  style={{
                    padding: "12px 10px",
                    textAlign: "center",
                    fontSize: 11,
                    fontWeight: 500,
                    color: "#fff",
                    whiteSpace: "nowrap",
                  }}
                >
                  {c.label}
                </th>
              ))}

              <th
                style={{
                  padding: "12px 14px",
                  textAlign: "center",
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#fff",
                }}
              >
                Actif
              </th>

              <th
                style={{
                  padding: "12px 14px",
                  textAlign: "center",
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#fff",
                }}
              >
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {regions.map(r => (
              <tr
                key={r.id}
                style={{
                  borderBottom: "0.5px solid #f0f0f0",
                  background:
                    success === r.id ? "#EAF3DE" : "white",
                  transition: "background 0.3s",
                }}
              >
                {/* Région */}
                <td
                  style={{
                    padding: "10px 14px",
                    fontWeight: 600,
                    color: "#0B3C5D",
                    position: "sticky",
                    left: 0,
                    background: "white",
                    whiteSpace: "nowrap",
                  }}
                >
                  {r.region}
                </td>

                {/* Champs numériques */}
                {columns.map(c => (
                  <td
                    key={c.field}
                    style={{
                      padding: "8px 6px",
                      textAlign: "center",
                    }}
                  >
                    <input
                      type="number"
                      step={c.step}
                      value={r[c.field] ?? 0}
                      onChange={e =>
                        update(
                          r.id,
                          c.field,
                          parseFloat(e.target.value)
                        )
                      }
                      style={{
                        width: 70,
                        padding: "5px 6px",
                        borderRadius: 6,
                        textAlign: "center",
                        border: "0.5px solid #ddd",
                        fontSize: 12,
                        color: "#0B3C5D",
                        outline: "none",
                      }}
                    />
                  </td>
                ))}

                {/* Actif */}
                <td
                  style={{
                    padding: "10px 14px",
                    textAlign: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={r.actif ?? true}
                    onChange={e =>
                      update(
                        r.id,
                        "actif",
                        e.target.checked
                      )
                    }
                    style={{
                      width: 16,
                      height: 16,
                      cursor: "pointer",
                    }}
                  />
                </td>

                {/* Actions */}
                <td
                  style={{
                    padding: "10px 14px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <button
                    onClick={() => loadHeuresPointe(r)}
                    style={{
                      padding: "6px 10px",
                      marginRight: 6,
                      borderRadius: 6,
                      border: "1px solid #B5D4F4",
                      background:
                        selectedRegion?.id === r.id
                          ? "#E6F1FB"
                          : "#fff",
                      color: "#185FA5",
                      fontSize: 12,
                      cursor: "pointer",
                    }}
                  >
                    ⏱️ Pointe
                  </button>

                  <button
                    onClick={() => save(r)}
                    disabled={saving === r.id}
                    style={{
                      padding: "6px 14px",
                      borderRadius: 6,
                      border: "none",
                      background:
                        success === r.id
                          ? "#3B6D11"
                          : saving === r.id
                            ? "#ccc"
                            : "#0B3C5D",
                      color: "#fff",
                      fontSize: 12,
                      cursor:
                        saving === r.id
                          ? "default"
                          : "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {success === r.id
                      ? "✅ Sauvé"
                      : saving === r.id
                        ? "..."
                        : "💾 Sauver"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Gestion des heures de pointe */}
      {selectedRegion && (
        <div
          style={{
            marginTop: 20,
            background: "#fff",
            borderRadius: 12,
            padding: 20,
            border: "0.5px solid #e5e5e5",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <div>
              <p
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#0B3C5D",
                  margin: 0,
                }}
              >
                ⏱️ Heures de pointe — {selectedRegion.region}
              </p>

              <p
                style={{
                  fontSize: 12,
                  color: "#888",
                  marginTop: 4,
                  marginBottom: 0,
                }}
              >
                Plusieurs plages horaires peuvent être configurées.
              </p>
            </div>

            <button
              onClick={() => setSelectedRegion(null)}
              style={{
                border: "none",
                background: "#f2f2f2",
                borderRadius: 6,
                padding: "6px 10px",
                cursor: "pointer",
              }}
            >
              ✕ Fermer
            </button>
          </div>

          {loadingHeures ? (
            <div style={{ color: "#888", fontSize: 13 }}>
              Chargement...
            </div>
          ) : (
            <>
              {heuresPointe.length === 0 && (
                <div
                  style={{
                    padding: 14,
                    background: "#f8f8f8",
                    borderRadius: 8,
                    color: "#888",
                    fontSize: 13,
                    marginBottom: 14,
                  }}
                >
                  Aucune heure de pointe configurée pour cette région.
                </div>
              )}

              {heuresPointe.map(h => (
                <div
                  key={h.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "10px 12px",
                    marginBottom: 8,
                    background: "#F7FAFC",
                    border: "1px solid #E5EAF0",
                    borderRadius: 8,
                    flexWrap: "wrap",
                  }}
                >
                  <input
                    type="time"
                    value={h.heure_debut}
                    onChange={e =>
                      updateHeureLocal(
                        h.id,
                        "heure_debut",
                        e.target.value
                      )
                    }
                    style={{
                      padding: "6px 8px",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                    }}
                  />

                  <span style={{ color: "#888" }}>→</span>

                  <input
                    type="time"
                    value={h.heure_fin}
                    onChange={e =>
                      updateHeureLocal(
                        h.id,
                        "heure_fin",
                        e.target.value
                      )
                    }
                    style={{
                      padding: "6px 8px",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                    }}
                  />

                  <span
                    style={{
                      fontSize: 13,
                      color: "#555",
                    }}
                  >
                    ×
                  </span>

                  <input
                    type="number"
                    min="0.01"
                    step="0.05"
                    value={h.multiplicateur}
                    onChange={e =>
                      updateHeureLocal(
                        h.id,
                        "multiplicateur",
                        parseFloat(e.target.value)
                      )
                    }
                    style={{
                      width: 75,
                      padding: "6px 8px",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                      textAlign: "center",
                    }}
                  />

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      fontSize: 12,
                      color: "#555",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={h.actif ?? true}
                      onChange={e =>
                        updateHeureLocal(
                          h.id,
                          "actif",
                          e.target.checked
                        )
                      }
                    />
                    Actif
                  </label>

                  <button
                    onClick={() => updateHeurePointe(h)}
                    style={{
                      padding: "6px 10px",
                      border: "none",
                      borderRadius: 6,
                      background: "#0B3C5D",
                      color: "#fff",
                      cursor: "pointer",
                      fontSize: 12,
                    }}
                  >
                    💾
                  </button>

                  <button
                    onClick={() => deleteHeurePointe(h)}
                    style={{
                      padding: "6px 10px",
                      border: "none",
                      borderRadius: 6,
                      background: "#FDECEC",
                      color: "#B42318",
                      cursor: "pointer",
                      fontSize: 12,
                    }}
                  >
                    🗑️
                  </button>
                </div>
              ))}

              {/* Ajouter une plage */}
              <div
                style={{
                  marginTop: 16,
                  padding: 14,
                  background: "#F7FAFC",
                  borderRadius: 8,
                  border: "1px dashed #B5D4F4",
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#0B3C5D",
                    marginBottom: 10,
                  }}
                >
                  ➕ Ajouter une heure de pointe
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    flexWrap: "wrap",
                  }}
                >
                  <input
                    type="time"
                    value={newHeure.heure_debut}
                    onChange={e =>
                      setNewHeure(prev => ({
                        ...prev,
                        heure_debut: e.target.value,
                      }))
                    }
                    style={{
                      padding: "7px 8px",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                    }}
                  />

                  <span style={{ color: "#888" }}>→</span>

                  <input
                    type="time"
                    value={newHeure.heure_fin}
                    onChange={e =>
                      setNewHeure(prev => ({
                        ...prev,
                        heure_fin: e.target.value,
                      }))
                    }
                    style={{
                      padding: "7px 8px",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                    }}
                  />

                  <span style={{ color: "#555" }}>×</span>

                  <input
                    type="number"
                    min="0.01"
                    step="0.05"
                    value={newHeure.multiplicateur}
                    onChange={e =>
                      setNewHeure(prev => ({
                        ...prev,
                        multiplicateur: parseFloat(
                          e.target.value
                        ),
                      }))
                    }
                    style={{
                      width: 75,
                      padding: "7px 8px",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                      textAlign: "center",
                    }}
                  />

                  <button
                    onClick={addHeurePointe}
                    disabled={savingHeure}
                    style={{
                      padding: "7px 14px",
                      borderRadius: 6,
                      border: "none",
                      background: savingHeure
                        ? "#ccc"
                        : "#185FA5",
                      color: "#fff",
                      cursor: savingHeure
                        ? "default"
                        : "pointer",
                      fontSize: 12,
                    }}
                  >
                    {savingHeure
                      ? "Ajout..."
                      : "Ajouter"}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {/* Aperçu calcul */}
      <div
        style={{
          marginTop: 20,
          background: "#fff",
          borderRadius: 12,
          padding: 20,
          border: "0.5px solid #e5e5e5",
        }}
      >
        <p
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#0B3C5D",
            marginBottom: 12,
          }}
        >
          🧮 Simulateur de prix — Saint-Louis
        </p>

        {regions
          .filter(r => r.region === "Saint-Louis")
          .map(r => {
            const dist = 5;
            const duree = 10;
            const approche = r.frais_approche_2km ?? 100;
            const multiplicateurRegion =
              r.multiplicateur ?? 1.0;

            const prixBrut =
              ((r.prix_base ?? 500) +
                (r.prix_par_km ?? 300) * dist +
                (r.prix_par_min ?? 10) * duree +
                approche) *
              multiplicateurRegion;

            const prix = Math.max(
              Math.round(prixBrut / 100) * 100,
              r.prix_minimum ?? 500
            );

            return (
              <div
                key={r.id}
                style={{
                  fontSize: 13,
                  color: "#555",
                }}
              >
                <div>
                  Trajet 5km, 10 min, chauffeur à 1.5km :
                </div>

                <div
                  style={{
                    fontSize: 20,
                    fontWeight: 700,
                    color: "#0B3C5D",
                    marginTop: 6,
                  }}
                >
                  {prix.toLocaleString("fr-FR")} CFA
                </div>

                <div
                  style={{
                    fontSize: 12,
                    color: "#aaa",
                    marginTop: 4,
                  }}
                >
                  Base {r.prix_base} + km{" "}
                  {Math.round(
                    (r.prix_par_km ?? 300) * dist
                  )} + durée{" "}
                  {Math.round(
                    (r.prix_par_min ?? 10) * duree
                  )} + approche {approche}
                  {" × région "}
                  {multiplicateurRegion}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
